import { render, staticRenderFns } from "./newuserHelp.vue?vue&type=template&id=637e633a&scoped=true&"
import script from "./newuserHelp.vue?vue&type=script&lang=ts&"
export * from "./newuserHelp.vue?vue&type=script&lang=ts&"
import style0 from "./newuserHelp.vue?vue&type=style&index=0&id=637e633a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637e633a",
  null
  
)

export default component.exports